import React from 'react';

import {ITaskCreationSingleVoyageMutateVoyage} from "@containers/singleVoyage/mutateVoyage/tasks/types";
import ItemTaskInfoMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/tasks/tasksList/item/ItemTaskInfoMutateSingleVoyage";
import PointTasksInfoContainerViewSingleVoyage
    from "@containers/singleVoyage/tasks/views/pointTasksInfo/PointTasksInfoContainerViewSingleVoyage";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";

interface IProps {
    tasks: ITaskCreationSingleVoyageMutateVoyage[]
    showIsComplete?: boolean
    voyageStatus: VoyageStatusSingleVoyage
    accountId: string | number
    currentWaypointId?: number
}

const TasksListMutateSingleVoyage = ({
                                         tasks,
                                         voyageStatus,
                                         accountId,
                                         currentWaypointId,
                                     }: IProps) => {

    const list = tasks?.length >= 1 && tasks.map((task, index) => {
        return (
            <ItemTaskInfoMutateSingleVoyage
                key={index}
                task={task}
                voyageStatus={voyageStatus}
                accountId={accountId}
                currentWaypointId={currentWaypointId}
                number={index + 1}
            />
        )
    })

    return (
        <PointTasksInfoContainerViewSingleVoyage
            hasNothingTasksMessage={!tasks?.length}
        >
            {list}
        </PointTasksInfoContainerViewSingleVoyage>
    )
};

export default TasksListMutateSingleVoyage;
